import apiBase from "@/api/unversioned/apiBase";
import { type AxiosRequestConfig } from "axios";
import type {
  VarianceRequestParams,
  VarianceRequestBody
} from "@/features/carrier-performance/composables/useVarianceData/types";

const baseURL = `${import.meta.env.VITE_API_BASE_URL}/carrier-performance/query`;

const varianceTrend = (params: VarianceRequestParams, body?: VarianceRequestBody, config?: AxiosRequestConfig) => {
  const queryString = new URLSearchParams(
    Object.entries(params)
      .filter(([, value]) => value !== undefined && value !== null)
      .flatMap(([key, value]) => (Array.isArray(value) ? value.map((v) => [key, String(v)]) : [[key, String(value)]]))
  ).toString();

  return apiBase("post", `${baseURL}/variance?${queryString}`, config, body);
};

export { varianceTrend };
